// extracted by mini-css-extract-plugin
module.exports = {"loader_css":"LoaderCss_loader_css__x902j"};